import { Chart, ChartArea, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip, MarkersVisualArgs, RenderEvent, SeriesVisualArgs } from "@progress/kendo-react-charts";
import { Switch } from "@progress/kendo-react-inputs";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import "hammerjs";
import { Fragment, useEffect, useState } from "react";
import { Circle as CircleGeometry } from '@progress/kendo-drawing/geometry';
import { Layout, Text } from '@progress/kendo-drawing';
import moment from "moment";
import { AppConstants } from "../../Shared/Constants/AppConstant";
import { academicMarkerVisual } from "../ReportUtils";

export const WeeklyBreakDownPdf = (props: any) => {
    //for donut chart 
    const [totalHours, setTotalHours] = useState<any>();
    const [totalMinutes, setTotalMinutes] = useState<any>();
    const [notes, setNotes] = useState<any>([]);
    const [isDccExceededContract, setIsDccExceededContract] = useState<any>();
    const [isIccExceededContract, setIsIccExceededContract] = useState<any>();
    const [totalSessions, setTotalSessions] = useState<any>();
    const [weekCommencing, setWeekCommencing] = useState<any>();
    const [contractedSessions, setContractedSessions] = useState<any>();
    const [iccPercentage, setIccPercentage] = useState<any>();
    const [contractPercentage, setContractPercentage] = useState<any>();

    //for categories 
    const [categories, setCategories] = useState<any>([]);

    //for sub categories
    const [subCategories, setSubCategories] = useState<any>([]);

    //line chart
    const [lineChartCategories, setLineChartCategories] = useState<any>([]);

    //To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map = new Map<number, string>();
        map.set(AppConstants.DCC_Category_Id, '#0967B1');
        map.set(AppConstants.ICC_Category_Id, '#DA1F6C');
        map.set(AppConstants.Non_Clinical_Work_Category_Id, '#008E82');
        map.set(AppConstants.Training_And_Supervision_Category_Id, '#6F4F9B');
        map.set(AppConstants.CPD_Category_Id, '#EA580D');
        map.set(AppConstants.Employer_Contract_Hours_Category_Id, 'grey');
        map.set(AppConstants.Total_Worked_Category_Id, '#FFDF00');
        map.set(AppConstants.Academic_Category_Id, '#000000');

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map.get(item.categoryId);
        }
    }

    //To map the catgories for line chart
    const mapSeries = (item: any, index : any) => {
        return (
            <ChartSeriesItem key={index} data={item.totalWorkHours} type="line"
                color={getColorForLineChart(item)}
                width={(item.categoryId === AppConstants.Total_Worked_Category_Id) || (item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 2 : 1}
                dashType={(item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id || item.isUserDefined || item.categoryId === AppConstants.Academic_Category_Id) ? 'dash' : 'solid'}
                highlight={
                    item.categoryId === AppConstants.Academic_Category_Id
                        ? { visible: false }
                        : undefined
                }
                markers={{
                    size: ((item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Total_Worked_Category_Id || item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 24 :
                        (item.categoryId === AppConstants.ICC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id) ? 15 :
                            (item.categoryId === AppConstants.CPD_Category_Id || item.isUserDefined) ? 9 :
                                (item.categoryId === AppConstants.Non_Clinical_Work_Category_Id || item.categoryId === AppConstants.Academic_Category_Id) ? 30 : 24),
                    type: ((item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Total_Worked_Category_Id || item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 'circle' :
                        (item.categoryId === AppConstants.ICC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id) ? 'square' :
                            (item.categoryId === AppConstants.CPD_Category_Id || item.isUserDefined) ? 'triangle' :
                                (item.categoryId === AppConstants.Non_Clinical_Work_Category_Id) ? 'cross' : 'circle'),
                    visible: (item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? false : true,
                    background: "none",
                    visual: item.categoryId === AppConstants.Academic_Category_Id ? academicMarkerVisual : undefined,
                }}
            />
        );
    }

    useEffect(() => {
        BuildDataForCharts(props.data);
    },[])

    //to display categories for no data
    const weekWithNoCategoriesData = [{ id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 1, totalDurationMinutes : 30 }];

    //to display sub categories for no data
    const weekWithNoSubCategoriesData = [
        { id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.4, percentage: 0, totalDurationMinutes: 30 },
        { id: 2, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.3, percentage: 0, totalDurationMinutes: 30 },
        { id: 3, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.2, percentage: 0, totalDurationMinutes: 30 },
        { id: 4, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.1, percentage: 0, totalDurationMinutes: 30 }];

    let subCategoriesToSet: any = [];

    //to get colors for category
    const getColorForCategory = (category: any, subCategoriesList: any) => {
        let subcategories = subCategoriesList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element, opacity);
            element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
            subCategoriesToSet.push(element);
        });

        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //to get colors for sub category
    const getColorForSubCategory = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    //to build data for charts
    const BuildDataForCharts = (firstWeekdata: any) => {
        if (firstWeekdata?.totalHours > 0 || firstWeekdata?.totalMinutes > 0) {
            firstWeekdata.weeklyBreakDownCategoryDtos.map((element: any) => {
                element.color = getColorForCategory(element, firstWeekdata.weeklyBreakDownSubCategoryDtos);
                element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
            });
            setTotalHours(firstWeekdata.totalHours);
            setTotalMinutes(firstWeekdata.totalMinutes);
            setTotalSessions(firstWeekdata.totalSessions);
            setNotes(firstWeekdata.notes);
            setWeekCommencing(firstWeekdata.weekCommencing);
            setIsDccExceededContract(firstWeekdata.dccTotal);
            setIsIccExceededContract(firstWeekdata.iccTotal);
            setContractedSessions(firstWeekdata.totalContractedSessions);
            setIccPercentage(firstWeekdata.totalIccPercentage);
            setContractPercentage(firstWeekdata.totalContractPercentage);
            setCategories(firstWeekdata.weeklyBreakDownCategoryDtos);
            setSubCategories(subCategoriesToSet);
            setLineChartCategories(firstWeekdata.lineChartCategoryDtos);
        } else {
            setTotalHours(0);
            setTotalMinutes(0);
            setTotalSessions(0);
            setNotes([]);
            setIsDccExceededContract(0);
            setIsIccExceededContract(0);
            setWeekCommencing(firstWeekdata.weekCommencing);
            setIccPercentage(0);
            setContractedSessions(0);
            setContractPercentage(0);
            setCategories(weekWithNoCategoriesData);
            setSubCategories(weekWithNoSubCategoriesData);
            setLineChartCategories([]);
        }
    }

    //to render donut center data
    let center: any;
    let radius: any;

    //To create visuals for donut chart center
    const visualHandler = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        center = e.center;
        radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRender = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (center) {
            const circleGeometry = new CircleGeometry([center.x, center.y], radius);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(totalHours + 'h ' + totalMinutes + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    //to set x axis values for line chart
    const weekRange = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    {props.weekIndex == 0 && (
                        <div className="col-lg-5 mb-2 p-0">
                            <div className="mb-0">
                                {props.isPublicHolidayToggleChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                                {!props.isPublicHolidayToggleChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                                <label className="form-check-label fs-5 ms-2">Exclude weeks with public holidays</label>
                            </div>
                            <div className="mb-0">
                                {props.isLeaveToggleChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                                {!props.isLeaveToggleChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                                <label className="form-check-label fs-5 ms-2">Exclude weeks with leave</label>
                            </div>
                            <div className="Container-fluid"></div><br />
                            <span className="text-muted fs-5">Weeks showing: {props.totalNumberOfWeeks}</span>
                        </div>
                    )}
                </div>
            </div>

            <p className="m-0">Week commencing {moment(weekCommencing).format('DD/MM/yyyy')}</p>
            {(totalHours > 0 || totalMinutes > 0) && (
                <div className="Container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <Chart transitions={false}>
                                <ChartTitle text="hours" position="top" align="left" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem
                                        title={{ text: "Day", position: "bottom" }}
                                        categories={weekRange}
                                    />
                                </ChartCategoryAxis>
                                <ChartSeries>
                                    {
                                        lineChartCategories.map(mapSeries)
                                    }
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                </div>
            )}
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6">
                        {totalHours == 0 && totalMinutes == 0 && (
                            <p className="mt-0">No activities in diary for this week.</p>
                        )}
                        {(totalHours > 0 || totalMinutes > 0) && (
                            <Chart transitions={false} onRender={onRender}>
                                <ChartTooltip background="#fff" />
                                <ChartLegend visible={false} />
                                <ChartArea background="none" />
                                <ChartSeries>
                                    <ChartSeriesItem visual={visualHandler}
                                        name="subCategories"
                                        width={500}
                                        type="donut"
                                        startAngle={0}
                                        field="totalDurationMinutes"
                                        categoryField="name"
                                        data={subCategories}
                                        colorField="color"
                                        size={40}
                                        holeSize={50}
                                        margin={3} >
                                    </ChartSeriesItem>
                                    <ChartSeriesItem visual={visualHandler}
                                        name="categories"
                                        width={500}
                                        type="donut"
                                        startAngle={0}
                                        field="totalDurationMinutes"
                                        categoryField="name"
                                        data={categories}
                                        colorField="color"
                                        size={60}
                                        holeSize={50}
                                        margin={3} >
                                    </ChartSeriesItem>
                                </ChartSeries>
                            </Chart>
                        )}
                    </div>
                    {(totalHours > 0 || totalMinutes > 0) && (
                        <>
                            <div className="col-lg-2">
                            </div>
                            <div className="col-lg-4 mt-5">
                                {categories && categories.map((category: any, index: any) => (
                                    <Fragment key={index}>
                                        <ExpansionPanel
                                            expandIcon="k-icon k-i-arrow-60-right"
                                            collapseIcon="k-icon k-i-arrow-60-down"
                                            style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                            expanded={true}
                                            tabIndex={0}
                                            key={category.id}
                                            title={
                                                <div className="row mt-2">
                                                    <span className="mr-2">
                                                        <svg width="50" height="50">
                                                            <circle cx="25" cy="25" r="25" fill={category.color} fillOpacity="0.3" />
                                                            <circle cx="25" cy="25" r="15" fill={category.color} fillOpacity="0.7" />
                                                            <circle cx="25" cy="25" r="5" fill={category.color} fillOpacity="1" />
                                                        </svg>
                                                        <label className="text-dark ps-2"><b>{category.name} - {category.totalHours?.toFixed(0)}h {category.totalMinutes?.toFixed(0)}m ({category?.percentage > 0 ? category?.percentage?.toFixed(1) : 0}%)</b></label>
                                                    </span>
                                                </div>
                                            }
                                        />
                                        {subCategories.filter((x: any) => x.categoryId == category.id).map((subCategory: any, index: any) => (
                                            <Fragment key={index}>
                                                {true && (
                                                    <div className="container-fluid">
                                                        <ExpansionPanelContent >
                                                            <div className="row mt-2">
                                                                <span className="col-1 ps-4 ms-1">
                                                                    <svg width="20" height="20">
                                                                        <circle cx="10" cy="10" r="10" fill={subCategory.color} />
                                                                    </svg>
                                                                </span>
                                                                <label className="col-5 ps-4 ms-1 pe-0 text-break">{subCategory.name}</label>
                                                                <label className="col-5 ps-1 pe-0 text-break">{subCategory.totalHours?.toFixed(0)}h {subCategory.totalMinutes?.toFixed(0)}m ({subCategory?.percentage > 0 ? subCategory?.percentage?.toFixed(1) : 0}%)</label>
                                                            </div>
                                                        </ExpansionPanelContent>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Notes data */}
                {notes.length > 0 && (
                    <div className="mt-4">
                        <div>
                            <h5 className="mb-1 text-dark">Notes for this week</h5>
                            {notes.map((item: any, index: any) => (
                                <div key={index}>
                                    <h5 className="text-muted mb-0">
                                        {moment(item.activityStartDate).format('DD/MM/yyyy')}{' '}
                                        {moment(item.activityStartDate).format('HH:mm')}-{moment(item.activityEndDate).format('HH:mm')}{' '}
                                        {item.categoryName}-{item.subCategoryName}<br />
                                    </h5>
                                    <span className="text-secondary">{item.notes}</span><br />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {contractedSessions > 0 && isDccExceededContract > contractedSessions ? (
                    <span className="red-text mb-2">
                        <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC is more than contracted hours</p>
                    </span>
                ) : null}<br />
                {contractedSessions > 0 && (isDccExceededContract && isIccExceededContract > contractedSessions) ? (
                    <span className="red-text mb-2">
                        <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC and ICC is more than contract hours.</p>
                    </span>
                ) : null}
                {iccPercentage > 0 ? (
                    <p className="mb-1">Your ICC is {iccPercentage.toFixed(0)}% of your DCC plus ICC time.</p>) : null}
                {contractPercentage > 0 ? (
                    <p>Your contract hours are {contractPercentage.toFixed(0)}% of your worked total.</p>
                ) : null}
            </div>
        </>
    );
} 